module.exports = __webpack_public_path__ + "img/tmb.eb2035e1.svg";